import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loaded: false
    },
    modules: {
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js